import { render, staticRenderFns } from "./ContactUsChatbase.vue?vue&type=template&id=acf60f78"
import script from "./ContactUsChatbase.vue?vue&type=script&lang=js"
export * from "./ContactUsChatbase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports